import { Routes, Route } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useSmoothScroll } from './hooks/useSmoothScroll'
import { useAuth } from './hooks/useAuth'
import ProtectedRoute from './components/Auth/ProtectedRoute'
import Navbar from './components/Layout/Navbar'
import Footer from './components/Layout/Footer'
import Loader from './components/Loader/Loader'
import Home from './pages/Home'
import AboutUs from './pages/AboutUs'
import Contact from './pages/Contact'
import Pricing from './pages/Pricing'
import Login from './pages/Auth/Login'
import Register from './pages/Auth/Register'
import ForgotPassword from './pages/Auth/ForgotPassword'
import ResetPassword from './pages/Auth/ResetPassword'
import Dashboard from './pages/Dashboard/Dashboard'
import DashboardHome from './pages/Dashboard/DashboardHome'
import Checklist from './pages/Dashboard/Checklist'
import BudgetManager from './pages/Dashboard/BudgetManager'
import GuestManager from './pages/Dashboard/GuestManager'
import GuestManagerIndex from './pages/Dashboard/GuestManager/GuestManagerIndex'
import TheLifesaverLink from './pages/Dashboard/GuestManager/TheLifesaverLink'
import RSVPFormBuilder from './pages/Dashboard/GuestManager/RSVPFormBuilder'
import CraftYourInvite from './pages/Dashboard/GuestManager/CraftYourInvite'
import GentleReminderTime from './pages/Dashboard/GuestManager/GentleReminderTime'
import WhoSitsWhere from './pages/Dashboard/GuestManager/WhoSitsWhere'
import SupplierManager from './pages/Dashboard/SupplierManager'
import SupplierManagerIndex from './pages/Dashboard/SupplierManager/SupplierManagerIndex'
import NumbersPlease from './pages/Dashboard/SupplierManager/NumbersPlease'
import TheChosenOnes from './pages/Dashboard/SupplierManager/TheChosenOnes'
import TimelineCreator from './pages/Dashboard/TimelineCreator'
import Lists from './pages/Dashboard/Lists'
import ListsIndex from './pages/Dashboard/Lists/ListsIndex'
import MustCaptureMoments from './pages/Dashboard/Lists/MustCaptureMoments'
import TheSoundtrack from './pages/Dashboard/Lists/TheSoundtrack'
import BloomBoard from './pages/Dashboard/Lists/BloomBoard'
import WeddingCargo from './pages/Dashboard/Lists/WeddingCargo'
// import Website from './pages/Dashboard/Website'
// Newsletter - Hidden, will be activated later
// import Newsletter from './pages/Dashboard/Newsletter'
import Profile from './pages/Dashboard/Profile'
import LifesaverForm from './pages/Public/LifesaverForm'
import RSVPInvitePage from './pages/Public/RSVPInvitePage'
import RSVPSearch from './pages/Public/RSVPSearch'
import RSVPForm from './pages/Public/RSVPForm'
import DialogContainer from './components/Dialog/DialogContainer'

function App() {
  const { loading: authLoading } = useAuth()
  useSmoothScroll()

  // Mostrar loader mientras se carga la autenticación
  // Los componentes hijos manejarán sus propios loaders para datos específicos
  if (authLoading) {
    return <Loader />
  }

  return (
    <div className="app">
      <DialogContainer />
      <Routes>
        {/* Public Form - No Navbar/Footer */}
        <Route path="/lifesaver-link/:token" element={<LifesaverForm />} />
        
        {/* All other routes with Navbar/Footer */}
        {/* Public RSVP Routes - No Navbar/Footer */}
        <Route path="/rsvp/:slug" element={<RSVPInvitePage />} />
        <Route path="/rsvp/:slug/search" element={<RSVPSearch />} />
        <Route path="/rsvp/:slug/form/:guestId" element={<RSVPForm />} />
        
        <Route path="*" element={
          <>
            <Navbar />
            <main>
              <Routes>
                {/* Landing Pages */}
                <Route path="/" element={<Home />} />
                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/pricing" element={<Pricing />} />
                
                {/* Auth Pages */}
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                
                {/* Profile - Protected Route (separate from dashboard) */}
                <Route
                  path="/profile"
                  element={
                    <ProtectedRoute>
                      <Profile />
                    </ProtectedRoute>
                  }
                />
                
                {/* Dashboard - Protected Routes */}
                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                >
                  <Route index element={<DashboardHome />} />
                  {/* Dashboard Sections */}
                  <Route path="checklist" element={<Checklist />} />
                  <Route path="budget-manager" element={<BudgetManager />} />
                  
                  {/* Guest Manager */}
                  <Route path="guest-manager" element={<GuestManager />}>
                    <Route index element={<GuestManagerIndex />} />
                    <Route path="the-lifesaver-link" element={<TheLifesaverLink />} />
                    <Route path="rsvp-form-builder" element={<RSVPFormBuilder />} />
                    <Route path="craft-your-invite" element={<CraftYourInvite />} />
                    <Route path="gentle-reminder-time" element={<GentleReminderTime />} />
                    <Route path="who-sits-where" element={<WhoSitsWhere />} />
                  </Route>
                  
                  {/* Supplier Manager */}
                  <Route path="supplier-manager" element={<SupplierManager />}>
                    <Route index element={<SupplierManagerIndex />} />
                    <Route path="numbers-please" element={<NumbersPlease />} />
                    <Route path="the-chosen-ones" element={<TheChosenOnes />} />
                  </Route>
                  
                  <Route path="timeline-creator" element={<TimelineCreator />} />
                  
                  {/* Lists */}
                  <Route path="lists" element={<Lists />}>
                    <Route index element={<ListsIndex />} />
                    <Route path="must-capture-moments" element={<MustCaptureMoments />} />
                    <Route path="the-soundtrack" element={<TheSoundtrack />} />
                    <Route path="bloom-board" element={<BloomBoard />} />
                    <Route path="wedding-cargo" element={<WeddingCargo />} />
                  </Route>
                  
                  {/* <Route path="website" element={<Website />} /> */}
                  {/* Newsletter - Hidden, will be activated later */}
                  {/* <Route path="newsletter" element={<Newsletter />} /> */}
                </Route>
              </Routes>
            </main>
            <Footer />
          </>
        } />
      </Routes>
    </div>
  )
}

export default App
